import React from 'react'
import { useFormContext } from 'react-hook-form'
import './checkbox.scss'

interface CheckboxProps {
	label: string
	fieldName: string
	handler: () => void
}

const Checkbox = ({ label, fieldName, handler }: CheckboxProps) => {
	const { register } = useFormContext()

	return (
		<div className="checkbox_container">
			<input
				className="checkbox"
				type="checkbox"
				onClick={handler}
				{...register(fieldName)}
			/>
			<label htmlFor="input">{label}</label>
		</div>
	)
}

export default Checkbox
